import {
    Box,
    Container,
    Flex,
    GridItem,
    Highlight,
    Image,
    Skeleton,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import React from "react";

import ProductCarousel from "@/components/general/ProductCarousel";

const PlacesCards = ({ data }) => {
    const router = useRouter();
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const isGreaterThanLg = useBreakpointValue({ base: false, lg: true });
    const isGreaterThanXl = useBreakpointValue({ base: false, xl: true });

    const showSkeleton = () => {
        if (isGreaterThanXl) {
            return (
                <Flex
                    w="100%"
                    h="183px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="5"
                    bg="white"
                >
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanLg) {
            return (
                <Flex
                    w="100%"
                    h="183px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="5"
                    bg="white"
                >
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else if (isGreaterThanMd) {
            return (
                <Flex
                    w="100%"
                    h="183px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="5"
                    bg="white"
                >
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                    <Skeleton w="197px" h="100%" borderRadius="10px" />
                </Flex>
            );
        } else {
            return (
                <Flex
                    w="100%"
                    h="183px"
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    gap="5"
                    bg="white"
                >
                    <Skeleton w="173px" h="100%" borderRadius="10px" />
                </Flex>
            );
        }
    };

    return (
        <Box
            bgColor="white"
            w="full"
            mx="auto"
            maxW="100%"
            paddingInline="0"
            position="relative"
            pb={10}
            pt={{ base: 10, md: 2 }}
        >
            <Box mb={10} align="center">
                <Text
                    as="h2"
                    fontSize={{ base: "md", md: "lg", lg: "2xl" }}
                    textAlign="center"
                    color="#002B49"
                >
                    <Highlight
                        query="¿Qué estás buscando?"
                        styles={{ fontWeight: "900", color: "#002B49" }}
                    >
                        ¿Qué estás buscando?
                    </Highlight>
                </Text>
            </Box>
            <Box mb={6}>
                <Container maxW="8xl" width="100%" mx="auto">
                    {(!data || data?.length === 0) && showSkeleton()}
                    {data?.length > 0 && (
                        <ProductCarousel>
                            {data.map((card, index) => (
                                <GridItem
                                    key={index}
                                    backgroundColor="#F6F6F6"
                                    height={{ base: "145px", sm: "183px" }}
                                    width={{ base: "135px", sm: "173px", md: "197px" }}
                                    borderRadius="lg"
                                    _hover={{
                                        transform: "translateY(-2px)",
                                        transition: "transform 0.3s ease-in-out",
                                    }}
                                >
                                    <Flex
                                        direction="column"
                                        height="100%"
                                        justify="space-evenly"
                                        align="center"
                                        cursor="pointer"
                                        onClick={() =>
                                            router.push(`/Buscar?tipo=${card.types.join(",")}`)
                                        }
                                    >
                                        <Image src={card.logo} alt={card.label} />
                                        <Text
                                            fontWeight={600}
                                            fontSize={{ base: "xs", md: "sm" }}
                                            color="#002B49"
                                        >
                                            {card.label}
                                        </Text>
                                    </Flex>
                                </GridItem>
                            ))}
                        </ProductCarousel>
                    )}
                </Container>
            </Box>
        </Box>
    );
};

export default PlacesCards;
